import React from "react";
import moment from "moment";
import { PublicRecord, TrueLinkCreditReportType } from "types";
import PublicRecordIcon from "assets/credit-report/public-record.svg";
import { Accordion } from "./Accordion";

interface CreditReportPublicRecordProps {
  publicRecords: TrueLinkCreditReportType["PulblicRecordPartition"];
  // eslint-disable-next-line react/require-default-props
  className?: string;
}
export const CreditReportPublicRecord = (
  props: CreditReportPublicRecordProps,
) => {
  const { publicRecords = [], className } = props;

  const getPublicRecordDetails = (publicRecord: PublicRecord) => {
    return [
      {
        title: "Bankruptcy type",
        value: publicRecord.Type?.[0]?.$.description || "N/A",
      },
      {
        title: "Status",
        value: publicRecord.Status?.[0]?.$?.description || "N/A",
      },
      {
        title: "Filed Type",
        value: publicRecord.AccountDesignator?.[0]?.$?.description || "N/A",
      },
      {
        title: "Reference Number",
        value: publicRecord.$.referenceNumber || "N/A",
      },
      {
        title: "Closing Date",
        value: publicRecord.Bankruptcy?.[0]?.$.dateResolved
          ? moment(publicRecord.Bankruptcy?.[0]?.$.dateResolved).format(
            "MM/DD/YYYY",
          )
          : "N/A",
      },
      {
        title: "Court with Juristiction",
        value: publicRecord.$.courtName || "N/A",
      },
      {
        title: "Liability",
        value: publicRecord.Bankruptcy?.[0]?.$.liabilityAmount
          ? `$${publicRecord.Bankruptcy?.[0]?.$.liabilityAmount}`
          : "N/A",
      },
      {
        title: "Exempt amount",
        value: publicRecord.Bankruptcy?.[0]?.$.exemptAmount
          ? `$${publicRecord.Bankruptcy?.[0]?.$.exemptAmount}`
          : "N/A",
      },
      {
        title: "Asset amount",
        value: publicRecord.Bankruptcy?.[0]?.$.assetAmount
          ? `$${publicRecord.Bankruptcy?.[0]?.$.assetAmount}`
          : "N/A",
      },
    ];
  };

  return (
    <div className={className}>
      <div>
        <h2 className="text-2xl font-bold flex items-center">
          <img alt="" src={PublicRecordIcon} className="inline mr-2" />
          Public Record
        </h2>
        <div className="mt-4 space-y-6">
          {publicRecords.map((publicRecordPartition) => {
            const publicRecord = publicRecordPartition.PublicRecord?.[0];
            if (!publicRecord) {
              return null;
            }

            return (
              <Accordion
                key={publicRecord.$.referenceNumber}
                className="mt-4"
                details={getPublicRecordDetails(publicRecord)}
                title="Account detail"
              >
                <div className="flex items-center justify-between">
                  <div className="flex flex-col">
                    <p>{publicRecord.Classification?.[0]?.$.description}</p>
                    <p className="text-xs font-normal text-neutral-600">
                      Reported{" "}
                      {moment(publicRecord.$?.dateFiled).format("MM/DD/YYYY")}
                    </p>
                  </div>
                </div>
              </Accordion>
            );
          })}
        </div>
      </div>
    </div>
  );
};
